interface FigureShotProps {
  src: string
  alt: string
  caption?: string
}

export function FigureShot({ src, alt, caption }: FigureShotProps) {
  return (
    <figure className="my-8 not-prose">
      <img
        src={src}
        alt={alt}
        className="w-full rounded border border-rule/40 shadow-sm"
        loading="lazy"
      />
      {caption && (
        <figcaption className="mt-2 text-sm text-muted font-mono tracking-wide">
          {caption}
        </figcaption>
      )}
    </figure>
  )
}
